import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "trezo-card p-[20px] md:p-[25px] rounded-md",
  style: {"background":"linear-gradient(120deg, #343a46 0%, #23272e 99.29%)"}
}
const _hoisted_2 = { class: "trezo-card-content" }
const _hoisted_3 = { class: "-mt-[10px]" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"trezo-card-header mb-[20px] flex items-center justify-between\"><div class=\"trezo-card-title\"><h5 class=\"mb-0 text-white\">Income Source</h5></div><div class=\"trezo-card-subtitle\"><span class=\"block text-white\"> Last 30 days </span></div></div>", 1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.isClient)
          ? (_openBlock(), _createBlock(_component_apexchart, {
              key: 0,
              type: "polarArea",
              width: "335",
              options: _ctx.incomeSource,
              series: _ctx.income
            }, null, 8, ["options", "series"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}